<template>
  <div>
    <NavBar />
    <Instructions v-if="step.instructions" v-bind="step" @response="next" />
    <Consent v-if="step.consent" v-bind="step" @response="next" />
    <SampleQuestion v-if="step.sampleQuestion" v-bind="step" @response="next" v-bind:progressBarDelayInMilliseconds="this.progressBarDelayInMilliseconds" />
    <Question v-if="step.question" v-bind="step" @response="next" v-bind:progressBarDelayInMilliseconds="this.progressBarDelayInMilliseconds" />
    <Complete v-if="step.complete" v-bind="step" @response="next" />
    <Feedback v-if="step.feedback" v-bind="step" @response="next" v-bind:progressBarDelayInMilliseconds="this.progressBarDelayInMilliseconds" />
    <TipReportScreen v-if="step.tipReportScreen" v-bind="step" @response="next" v-bind:progressBarDelayInMilliseconds="this.progressBarDelayInMilliseconds" />
    <Debug v-if="debugLogEntries" v-bind="step" />
    <MouseTracking v-if="step.question" @mouseLocation="onMouseLocation" />
  </div>
</template>

<script>
import NavBar from "@/views/tests/NavBar.vue";
import Instructions from "@/views/tests/test/Instructions.vue";
import Consent from "@/views/tests/test/Consent.vue";
import SampleQuestion from "@/views/tests/test/SampleQuestion.vue";
import Question from "@/views/tests/test/Question.vue";
import Feedback from "@/views/tests/test/Feedback.vue";
import TipReportScreen from "@/views/tests/test/TipReportScreen.vue";
import Complete from "@/views/tests/test/Complete.vue";
import Debug from "@/views/tests/test/Debug.vue";
import MouseTracking from "@/views/tests/test/MouseTracking.vue";

export default {
  components: {
    NavBar,
    Instructions,
    Consent,
    SampleQuestion,
    Question,
    Feedback,
    TipReportScreen,
    Complete,
    Debug,
    MouseTracking,
  },
  props: {
    testId: String,
  },
  data() {
    return {
      step: {},
      timestamp: null,
      mouseLocations: [],
      progressBarDelayInMilliseconds: 500,
    };
  },
  computed: {
    debugLogEntries() {
      if (this.step.debugLogEntries == null || this.step.debugLogEntries.length == 0) return null;
      return this.step.debugLogEntries;
    },
  },
  mounted() {
    this.next();
  },
  methods: {
    onMouseLocation(x, y) {
      this.mouseLocations.push({
        timestamp: new Date(),
        viewportHeight: window.innerHeight,
        viewportWidth: window.innerWidth,
        mouseX: x,
        mouseY: y,
      });
    },
    next(response) {
      const payload = {
        promptTypeCode: this.step.promptTypeCode,
        promptCode: this.step.promptCode,
        promptResponseCode: response,
        durationInMilliseconds: this.timestamp ? new Date() - this.timestamp : null,
        mouseLocations: this.mouseLocations,
        modeCode: this.$route.query.mode || null,
      };

      return this.$axios
        .post(`/v1/tests/${this.testId}/next`, payload)
        .then(res => {
          this.$i18n.locale = res.data.languageCode;
          this.step = res.data;
          this.$forceUpdate();
          this.timestamp = new Date();
          this.mouseLocations = [];
        })
        .catch(() => this.$router.push("/not-found"));
    },
  },
};
</script>
